import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_TEL } from "../data";

// Botón flotante de llamada — solo en móvil, encima del de WhatsApp.
export const CallButton = () => (
  <motion.a
    href={`tel:${PHONE_TEL}`}
    data-testid="call-float-button"
    aria-label="Llamar por teléfono"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ duration: 0.5, delay: 3, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="sm:hidden fixed bottom-24 right-6 z-[70] grid place-items-center w-14 h-14 bg-electric text-white rounded-full shadow-lg shadow-black/20"
  >
    <Phone size={24} />
  </motion.a>
);
